import { useCallback, useEffect } from 'react';

import api from '../../api/api';
import { useAppContext } from '../../AppContext';
import { User } from '../../models/User';
import { useHttpFetchApi } from '../http/useHttpFetch';

export function useGetCurrentUser() {
  const { logError } = useAppContext();
  const { loading, error, getJson } = useHttpFetchApi();
  useEffect(
    () => void (error && logError('Get Current User Error', error)),
    [error, logError]
  );
  const getUser = useCallback(
    async (userId?: number) => {
      const accessToken = await api.getAccessToken();
      const headers = {
        [api.environment.accessTokenKey]: `Bearer ${accessToken}`
      };

      return getJson<User>(
        userId ? `users/${userId}` : 'users/me',
        { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone },
        { headers }
      );
    },
    [getJson]
  );

  return { loadingUser: loading, userError: error, getUser };
}
